module.exports = __webpack_public_path__ + "img/MEG300_R.9dc4f67e.png";